import { validateAdvancedFilters } from './validateAdvancedFilters.js';
import { validateConditional } from './validateConditional.js';

export const validateIfElse = async ({ step, status }) => {
  const result =
    step?.arguments?.conditions?.filterSet?.length > 0 //
      ? await validateAdvancedFilters({ conditions: step?.arguments?.conditions, status })
      : await validateConditional({ condition: step?.arguments, status });

  if (result.status !== 'valid') {
    return { ...result, id: 'go-to-config' };
  }

  return { status: 'valid' };
};
